import { configHeaders } from "../comfig";

const productsEndPoint = `${process.env.NEXT_PUBLIC_BBA_API_URI}/v2/products`;

export async function getProductBySku(sku) {
  if (!sku) return;
  const url = `${productsEndPoint}?saleorId=${sku}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache",
      headers: configHeaders(),
    });
    return res.json();
  } catch (error) {
    console.log(error);
    return {};
  }
}
